import { logger } from '@gem/modules/logger';

import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';

export function handleCoinfideHost(property: IClientConfigProperty): void {
  try {
    const hosts: string[] = JSON.parse(property.value);
    Entities.marketplace.setMarketHosts(hosts);
  } catch (error) {
    logger.get('clientConfig').error('coinfideHost', error);
  }
}
